/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

import { colorClassNames } from '../../styles/Colors';

const IconFileDownload = (props) => (
  <svg width="56px" height="56px" viewBox="0 0 56 56" style={props.style}>
    <g transform="translate(-57 316)">
      <mask id="icon-filedownload-b">
        <path fill="#fff" d="M-1-1h16v18H-1z" transform="translate(78 -296)" />
        <use transform="translate(78 -296)" xlinkHref="#icon-filedownload-a" />
      </mask>
      <g mask="url(#icon-filedownload-b)">
        <use className={colorClassNames.fill(props.color)} transform="translate(78 -296)" xlinkHref="#icon-filedownload-c" />
      </g>
    </g>
    <defs>
      <path id="icon-filedownload-a" d="M13.146 6.854A.5.5 0 0 0 12.793 6H10.5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.5.5v5a.5.5 0 0 1-.5.5H1.207a.5.5 0 0 0-.353.854l5.792 5.792a.5.5 0 0 0 .708 0l5.792-5.792z" />
      <path id="icon-filedownload-c" d="M0 16a.5.5 0 0 0 0 1v-1zm14 1a.5.5 0 0 0 0-1v1zM0 17h14v-1H0v1zM13.146 6.854l.708.707-.708-.707zm-12.292 0l-.708.707.708-.707zM12.793 5H10.5v2h2.293V5zM11 5.5v-5H9v5h2zM9.5-1h-5v2h5v-2zM3 .5v5h2v-5H3zM3.5 5H1.207v2H3.5V5zM.146 7.56l5.793 5.794 1.415-1.415L1.56 6.146.146 7.561zm7.915 5.794l5.793-5.793-1.415-1.415-5.793 5.793 1.415 1.415zM12.793 7a.5.5 0 0 1-.354-.854l1.415 1.415C14.799 6.616 14.129 5 12.793 5v2zM10.5 5a.5.5 0 0 1 .5.5H9A1.5 1.5 0 0 0 10.5 7V5zM11 .5A1.5 1.5 0 0 0 9.5-1v2A.5.5 0 0 1 9 .5h2zM4.5-1A1.5 1.5 0 0 0 3 .5h2a.5.5 0 0 1-.5.5v-2zM3 5.5a.5.5 0 0 1 .5-.5v2A1.5 1.5 0 0 0 5 5.5H3zM1.207 5C-.129 5-.799 6.616.147 7.56L1.56 6.147A.5.5 0 0 1 1.207 7V5zm4.732 8.354a1.5 1.5 0 0 0 2.122 0l-1.415-1.415a.5.5 0 0 1 .708 0l-1.415 1.415z" />
    </defs>
  </svg>
);
IconFileDownload.propTypes = {
  color: colorClassNames.nameProp,
  style: PropTypes.object,
};
IconFileDownload.defaultProps = {
  color: 'black',
};

export default IconFileDownload;
